import colors from 'styles/colors';

const AuthStyles = {
  page: {
    background: colors.background.main,
    height: '100%',
    '@media (max-width: 768px)': {
      padding: '20px',
      overflowY: 'auto',
    },
  },
  header: {
    padding: '16px 0',
    textAlign: 'center',
    '@media (max-width: 768px)': {
      padding: '0 0 16px 0',
    },
  },
  content: {
    padding: '0 20px 20px 20px',
    '@media (max-width: 768px)': {
      padding: '0',
    },
  },
  advert: {
    background: 'linear-gradient(180deg, #02091C 0%, #011129 25.46%, #0D1E3B 69.8%, #071323 100%)',
    borderRadius: '32px',
    maxWidth: '728px',
    '@media (max-width: 768px)': {
      maxWidth: '100%',
      padding: '20px',
      marginBottom: '110px',
    },
  },
  advertJobScreenshot: {
    height: '275px',
    marginLeft: '0',
    marginTop: '-12px',
    marginBottom: '-6px',
    '@media (max-width: 768px)': {
      height: '190px',
      position: 'relative',
      left: '-20px',
      top: '25px',
      marginBottom: '0',
      marginTop: '0',
    },
  },
  advertSlogans: {
    padding: '40px 50px 0 50px',
    '@media (max-width: 768px)': {
      padding: '20px',
    },
  },
  advertTitle: {
    color: colors.text.primary,
    paddingBottom: '25px',
    '@media (max-width: 768px)': {
      fontSize: '1.25rem',
      textAlign: 'center',
    },
  },
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
    display: 'flex',
    gap: '35px',
    justifyContent: 'center',
    alignItems: 'center',
    '@media (max-width: 768px)': {
      flexDirection: 'column-reverse',
      alignItems: 'center',
      gap: '20px',
    },
  },
  sloganContainer: {
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 768px)': {
      marginBottom: '4px',
    },
  },
  sloganIcon: {
    width: '32px',
    paddingRight: '5px',
  },
  slogan: {
    color: colors.text.primary,
    lineHeight: '50px',
    '@media (max-width: 768px)': {
      lineHeight: '30px',
      fontSize: '1rem',
    },
  },
  authContainer: {
    width: '450px',
    minWidth: '350px',
    '& main': {
      width: '100% !important',
      '&>div': {
        width: '100% !important',
      },
    },
    '@media (max-width: 768px)': {
      width: '100%',
      padding: '20px',
      maxWidth: '350px',
    },
  },
};

export default AuthStyles;
